import React from "react";
import ReactDOM from "react-dom";
import {MiniGrantAwardees} from "../components/MiniGrantAwardees";

export const insertMiniGrantAwardees = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="mini-grant-awardees"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<MiniGrantAwardees />, element);
  });
};
